<template>
  <v-app id="LEIF">

    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>LEIF</span>
        <span class="font-weight-light">PARK SKATE</span>
        <span class="font-weight-light showonlargerscreen"> OCH GEMENSKAP</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-md-and-down">
         <v-btn
          v-for="item in menu"
          :key="item.icon"
          @click="showCenterItem(item.link)"
          flat
        >{{ item.title }}</v-btn>
      </v-toolbar-items>
      <v-menu class="hidden-lg-and-up">
        <v-toolbar-side-icon slot="activator"></v-toolbar-side-icon>
        <v-list>
          <v-list-tile v-for="item in menu" :key="item.icon" @click="showCenterItem(item.link)">
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
             </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>

    <v-parallax height=300 style="margin-top: 86px" :src="require('@/assets/skate3-smaller.jpeg')">
      <div style="width: auto; height: auto;">
      <img style="display: block; margin: auto; width: 160px; height: auto; border: 12px solid #E51F32; padding: 30px 15px 30px 15px; box-shadow: 6px 8px 12px rgba(0, 0, 0, .5)" src="@/assets/LEIF_LOGO.png"/>
      </div>
    </v-parallax>

    <maincenter/>

    <v-parallax height=300 style="margin-top: 0;" :src="require('@/assets/skate2.jpg')">
      <v-container fluid >
        <v-layout align-center justify-space-around row wrap style="height: 300px;">
          <v-flex xs5 sm5 lg2>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container fluid>
                    <v-layout>
                      <img :src="require('@/assets/logos/arvsfonden-logotyp-rgb-svart.png')" style="display: block; margin: auto; max-width: 100px; max-height: 100px;">
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
          <v-flex xs5 sm5 lg2>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container fluid>
                    <v-layout row wrap>
                      <img :src="require('@/assets/logos/Leader+svartvit.jpg')" style="display: block; margin: auto; max-width: 100px; max-height: 100px;">
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
          <v-flex xs5 sm5 lg2>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container fluid>
                    <v-layout row wrap>
                      <img :src="require('@/assets/logos/EU-flagga+Europeiska+jordbruksfonden+svartvit.jpg')" style="display: block; margin: auto; max-width: 100px; max-height: 90px ;">
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
          <v-flex xs5 sm5 lg2>
            <v-hover>
            <v-card slot-scope="{ hover }"
            :class="`elevation-${hover ? 12 : 2}`"
            class="mx-auto">
              <v-flex xs12>
                <v-card>
                  <v-container>
                    <v-layout row wrap >
                      <img :src="require('@/assets/logos/KOMMUN21.jpg')" style="display: block; margin: auto; max-width: 100%; max-height: 90px; width: auto">
                    </v-layout>
                  </v-container>
                </v-card>
              </v-flex>
            </v-card>
          </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </v-parallax>
    <v-footer class="pa-3">
    <v-spacer></v-spacer>
    <div>&copy; LEIF{{ new Date().getFullYear() }}</div>
    </v-footer>

    <v-dialog v-if="modals.vractive" v-model="modals.vractive" transition="dialog-bottom-transition" max-width="80%">
      <v-card style="padding: 20px; text-align: center; color: white; background: black;">DOES NOT WORK ON IOS / ANDROID</v-card>
        <v-card>
          <vrcenter />
        </v-card>
        <v-card style="padding: 20px; text-align: center; color: white; background: black;">CLICK TO USE MOUSE / ESC to release<br /> USE W, S, A, S & SPACE</v-card>
    </v-dialog>

    <v-dialog v-if="modals.movieactive" v-model="modals.movieactive" transition="dialog-bottom-transition" width="80%">
      <filmcenter />
    </v-dialog>

    <v-dialog v-if="modals.exibitionactive" v-model="modals.exibitionactive" transition="dialog-bottom-transition" width="80%">
      <iframe width="100%" height="1000px" src="https://www.skate2019.se/" />
    </v-dialog>

  </v-app>
</template>

<script>
import maincenter from '@/components/maincenter'
import vrcenter from '@/components/vrcenter'
import filmcenter from '@/components/filmcenter'

export default {
  name: 'App',
  components: {
    maincenter,
    vrcenter,
    filmcenter
  },
  data () {
    return {
      modals: {
        vractive: false,
        movieactive: false,
        exibitionactive: false
      },
      clientWidth: 0,
      menu: [
        // { icon: 'home', title: 'PARKEN' },
        // { icon: 'competitions', title: 'TÄVLINGAR' },
        // { icon: 'project', title: 'PROJEKT' },
        // { icon: 'community', title: 'FÖRENINGEN' },
        // { icon: 'support', title: 'STÖTTA OSS' },
        // { icon: 'camp', title: 'CAMP' },
        { icon: 'vr', title: 'VR', link: 'vractive'},
        { icon: 'movie', title: 'FILM', link: 'movieactive' },
        { icon: 'exibition', title: 'UTSTÄLLNING', link:'http://www.skate2019.se/' }
      ]
    }
  },
  computed: {
  },
  methods: {
    menuItems () {
      return this.menu
    },
    showCenterItem(e) {

      switch (e) {
        case 'vractive':
          this.modals.vractive = true
          break;
        case 'movieactive':
          this.modals.movieactive = true
          break;
        case 'http://www.skate2019.se/':
          this.modals.exibitionactive = true
          // window.open('http://www.skate2019.se/', '_blank')
          break;
      }
    },
    closeCenterItems () {
      this.modals.vractive = false
      this.modals.movieactive = false
      this.modals.exibitionactive = false
    }
  },
  mounted () {
  }
}
</script>
<style scoped>

@media (max-width: 1342px) {
  .showonlargerscreen {
    display: none;
  }
}

</style>
